import Immutable from "immutable";

import { Client } from "resourceModels";
import getAPIRoot from "services/api-root";

export default class SalesforcePlatformRecord extends Immutable.Record({
  name: "salesforce_liveagent",
  fullName: "Salesforce Chat",
  enabled: false,
  salesforceHostnameUrl: "",
  organizationId: "",
  deploymentId: "",

  accessToken: "",
  refreshToken: "",

  auth: Immutable.Map({
    instanceUrl: "",
    redirectUri: `${process.env.NODE_ENV === "production"
      ? getAPIRoot()
      : "https://test.api.ngrok.ada.support"
    }/oauth/salesforce_liveagent`,
    clientId: "",
    clientSecret: ""
  }),

  isVisibleToClient(client: Client): boolean {
    return client.hasFullSitePrivileges && client.features.get("adaGlassSalesforce");
  }
}) {}
